import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { CISecondaryButton } from 'common/viewcomp/forms/buttons';

interface Props {
    onClick: () => void;
}

export const ActivatePatientButton = ({ onClick }: Props): ReactElement => {
    const { t } = useTranslation('auth');

    return (
        <CISecondaryButton
            className="new-patient-register"
            type="button"
            id="registerPatient"
            fullWidth
            onClick={onClick}
        >
            {t('login.patient_activate')}
        </CISecondaryButton>
    );
};
